import { Routes } from "@angular/router";

export const eventsCalendarRoutes: Routes = [
  {
    path: "",
    title: "CALENDAR.TITLE",
    loadComponent: () => import("./pages/events-calendar/events-calendar.component").then((c) => c.EventsCalendarComponent),
  },
];
